module.exports = __webpack_public_path__ + "img/produit_5.4b026a2e.png";